import React, { useState } from "react";
import ThemedBlock from "components/atoms/ThemedBlock";
import Button from "theme/Button";
import i18n from "utils/i18n";
import _ from "lodash";
import Ajax from "utils/request/ajax";
import Title from 'components/atoms/Title'
import Description from 'components/atoms/Description'
import HelperString from 'utils/helper-string'
import HelperAlerts from 'utils/HelperAlerts'
import ThemedRangeDatepicker from 'components/atoms/ThemedRangeDatepicker'
import ThemedDatepicker from 'components/atoms/ThemedDatepicker'
import Icon from 'components/atoms/Icon'
import { IconSystemConstants } from 'utils/constants/IconNameConstants'
import Translate from 'utils/translate'
import { configClient } from 'components/provider/ConfigProvider'
import { openUrl } from 'utils/helper-url'
import HelperDate, { dateFormat } from 'utils/helper-date'
import { layoutStyles } from 'styles/layout';
import { StyleSheet, View } from 'react-native';

export const ReportsByDate = {
	bookingsOnDay: {
		identifier: 'bookings_on_day'
	},
	lunchesOnDay: {
		identifier: 'lunches_on_day'
	},
	parkingsOnDay: {
		identifier: 'parking_on_day'
	},
	employeeBookingCount: {
		identifier: 'employee_booking_count'
	},
	transportsOnDay: {
		identifier: 'transports_on_day'
	},
	workdays: {
		identifier: 'workdays'
	},
	commutes: {
		identifier: 'commutes'
	},
	credits: {
		identifier: 'credits'
	},
	custom: {
		identifier: 'custom_on_day'
	},
}

const ManagementReportsReportByDate = ({ employee, multiDate = false, report, timeslotKind }) => {

	const [ generating, setGenerating ] = useState( false )
	const [ selectedDate, setSelectedDate ] = useState( HelperDate.defaultDateRange() )

	const [ url, setUrl ] = useState( null )

	const setSelectedSingleDate = ( selectedDate ) => {
		setSelectedDate([ selectedDate, selectedDate ])

		setUrl( null )
	}

	const setSelectedMultiDate = ( selectedRange ) => {
		setSelectedDate( selectedRange )
		
		setUrl( null )
	}

	const generate = () => {
		if( generating ) {
			return;
		}

		// if we already generated the outcome don't do it again!!
		if( url !== null ) {
			openUrl( url );
			return;
		}

		const guid = _.get( employee, 'guid', '' );
		
		// Create the variables
		let variables = {
			guid: guid,
			identifier: report.identifier,
			sub_kind: _.get( timeslotKind, 'sub_kind', '' ),
		}

		if( multiDate === true ) {
			// When not set then we set it
			if( selectedDate[ 1 ] === null ) {
				selectedDate[ 1 ] = selectedDate[ 0 ]
			}
			
			variables = {
				...variables,
				date: HelperDate.date( selectedDate[ 0 ] ).format( dateFormat.DATE ),
				date_till: HelperDate.date( selectedDate[ 1 ] ).format( dateFormat.DATE )
			}
		} else {
			variables.date = HelperDate.date( selectedDate ).format( dateFormat.DATE )
		}

		Ajax.request( configClient.url() + '/connection/rest/management/generate_report', {
			variables,
			onStart: () => {
				setGenerating( true )
			},
			onSuccess: ( result ) => {
				let url = null;

				switch( result.status ) {
					case 'success':
						url = result.url;
						openUrl( url );
						break;

					default:
						captureError( result.error );
						break;
				}

				setGenerating( false )
				setUrl( url )
			},
			onError: ( result ) => {
				setGenerating( false )
				setUrl( null )

				captureError( result.error );
			},
		});
	}

	const captureError = ( error ) => {
		switch( error ) {
			case 'no_output':
				HelperAlerts.alert( '', i18n.t('management:pages.reports.index.errors.no_output') );
				break;

			case 'access_denied':
				HelperAlerts.alert( '', i18n.t('management:pages.reports.index.errors.access_denied') );
				break;

			default:
				HelperAlerts.alert( '', i18n.t('management:pages.reports.index.errors.something_went_wrong') );
				break;

		}
	}

	let identifier = report.identifier;

	return (
		<ThemedBlock
			key={ HelperString.hash( 'ManagementReportsReportBySingleDate', report.identifier ) }
			containerStyle={ layoutStyles.flexOne }
			style={ layoutStyles.flexOne }
			mediumPadding
			shadow>

			{ i18n.exists(`management:reports.${identifier}.title`) && (
				<Title>
					{i18n.t(`management:reports.${report.identifier}.title`)}
				</Title>
			)}

			{ timeslotKind !== null && (
				<Title>
					{ Translate.field( timeslotKind, 'name' ) }
				</Title>
			)}

			{ i18n.exists(`management:reports.${identifier}.description`) && (
				<Description>
					{ i18n.t(`management:reports.${report.identifier}.description`) }
				</Description>
			)}

			<View
				style={ styles.bottomContainer }>

				{  multiDate === true ? (
					<ThemedRangeDatepicker
						range={ selectedDate }
						onSelect={ setSelectedMultiDate }
					/>
				) : (
					<ThemedDatepicker
						date={ selectedDate[ 0 ] }
						accessoryRight={ <Icon icon={ IconSystemConstants.CALENDAR } /> }
						onSelect={ setSelectedSingleDate }
					/>
				)}

				<Button
					onPress={ generate.bind( this ) }
					isLoading={ generating }
					size={"small"}>

					{ i18n.t('management:pages.reports.index.btn_download') }
				</Button>
			</View>
		</ThemedBlock>
	);
}

const styles = StyleSheet.create({
	bottomContainer: {
		flex: 1,
		alignContent: 'flex-end',
		justifyContent: 'flex-end',
		gap: 5,
	}
});

export default ManagementReportsReportByDate
